import React from "react";
import "../../../../css/Turismo/turismo.css";

const imagenes = [
  require("../../../img/navidad/navidad-gaucha-1.jpg"),
  require("../../../img/navidad/navidad-gaucha-2.jpg"),
  require("../../../img/navidad/navidad-gaucha-3.jpg"),
  require("../../../img/navidad/navidad-gaucha-4.jpg"),
  require("../../../img/navidad/navidad-gaucha-5.jpg"),
  require("../../../img/navidad/navidad-gaucha-6.jpg"),
  require("../../../img/navidad/navidad-gaucha-7.jpg"),
];

const NavidadGaucha = () => (
  <div>
    <div
      className="navidad-gaucha text-center"
      style={{
        backgroundImage: `url(${require("../../../img/ng-2.jpeg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundPositionY: "30px",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundAttachment: "fixed",
        position: "relative",
        height: 450,
        marginBottom: 30,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 1,
        }}
      />
    </div>
    <div className="container">
      <div className="info-navidad">
        <h1 className="text-center"><strong>FIESTA NACIONAL DE LA NAVIDAD GAUCHA</strong></h1>
        <h3 className="text-center">
          <strong>Declarada de Interés Legislativo por la honorable cámara Legislativa de Córdoba en 1992</strong>
        </h3>
        <br />
        <h4><strong>Declarada Fiesta Nacional en el año 2012</strong></h4>
        <p>
          Su primera edición se llevó a cabo en diciembre de 1962, esta festividad representa la celebración del nacimiento del niño gaucho envuelto en un marco de ángeles y pastores, en un pesebre viviente. Como desde aquel diciembre de 1962, cada año hasta la actualidad se celebra esta Fiesta Nacional, tomándose como referencia el fin de semana previo a la Navidad para su realización, situándose sobre la Plaza “Presbítero Enrique Visca Caviglia”, frente a la Parroquia Sagrado Corazón. Es un evento de concurrencia popular al que asisten de 3.000 a 6.000 personas de Oliva y la región.
          A lo largo de su historia el festival ha presentado en su escenario una gama de artistas sumamente reconocidos en el ámbito del folclore. Algunos de ellos son: Galleguillo, Jorge Rojas, Lucio Indio Rojas, Los Tekis, Los Cantores del Alba, Facundo Toro, Los del Suquia, Mercedes Sosa, Los Chalchaleros, entre otros.
          Esta festividad marca el inicio de la temporada de festivales folclóricos en la provincia.
        </p>
        <div className="row">
          <section className="col-12">
            <div id="carouselNavidadGaucha" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner">
                {imagenes.map((img, idx) => (
                  <div className={`carousel-item${idx === 0 ? " active" : ""}`} key={idx}>
                    <img
                      src={img}
                      className="d-block w-100"
                      alt={`navidad-gaucha-${idx + 1}`}
                      style={{ height: "auto", objectFit: "cover" }}
                    />
                  </div>
                ))}
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselNavidadGaucha" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Anterior</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselNavidadGaucha" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Siguiente</span>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
);

export default NavidadGaucha;